import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_project-user",
  "use": "svg_project-user-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"svg_project-user\"><circle cx=\"4.857\" cy=\"2.857\" r=\"2.857\" fill=\"currentColor\" /><path d=\"M0 9.286a3.571 3.571 0 0 1 3.571-3.572H6.43A3.571 3.571 0 0 1 10 9.286V10H0v-.714Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol